import colors from '@/theme/colors';
import { Flex, FlexProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  height?: FlexProps['height'];
}

const MYOLinearGradient = ({ height, children }: Props) => {
  return (
    <Flex
      width={'100%'}
      height={height}
      background={`linear-gradient(180deg, ${colors.primary[500]} 0%, #DC733E 100%)`}
    >
      {children}
    </Flex>
  );
};

export default MYOLinearGradient;
